import { render, staticRenderFns } from "./CasosCorreos.vue?vue&type=template&id=84d4940e&scoped=true"
import script from "./CasosCorreos.vue?vue&type=script&lang=js"
export * from "./CasosCorreos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d4940e",
  null
  
)

export default component.exports